module.exports = "https://cdn.hellotech.com/client-assets/StreamingDevice_86432b639286160f2451bdf8fc21f233.png";